import script from "./SingleQueueListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleQueueListComponent.vue?vue&type=script&setup=true&lang=js"

import "./SingleQueueListComponent.vue?vue&type=style&index=0&id=4cea645e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cea645e"]])

export default __exports__